import { FC, useEffect, useState } from 'react';
import BordOneToneIcon from '../../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { patchAgentChatScore } from '../../../../../../../services/agentChat.service';
import { AGENT_CHAT_SCORE_OPTIONS, IAgentResponseData } from '../../../../../../../types/agentChat.types';
import { displayErrorNotification } from '../../../../../../../utils/displayNudosStandardNotifications';
import './AgentChatVotingSystem.scss';

const AgentChatVotingSystem: FC<AgentChatVotingSystemProps> = ({ agentChatResponse, refreshHistory }) => {
  const [voted, setVoted] = useState<AGENT_CHAT_SCORE_OPTIONS>();

  const handleVoteAgentChat = async (score: AGENT_CHAT_SCORE_OPTIONS) => {
    if (!agentChatResponse.id) return;
    try {
      await patchAgentChatScore(agentChatResponse.id, { score });
      setVoted(score);
      refreshHistory();
    } catch (error) {
      displayErrorNotification();
    }
  };

  useEffect(() => {
    if (agentChatResponse.score !== null) setVoted(agentChatResponse.score);
    if (agentChatResponse.score === null) setVoted(undefined);
  }, [agentChatResponse]);

  return (
    <div className="agentChatVotingSystem">
      <div className="agentChatVotingSystemText">¿Te fue útil esta respuesta?</div>
      <div
        className={`voteButton${voted === AGENT_CHAT_SCORE_OPTIONS.LIKE ? ' votedLike' : ''}`}
        onClick={() => handleVoteAgentChat(AGENT_CHAT_SCORE_OPTIONS.LIKE)}
      >
        <BordOneToneIcon variant="thumbsUp" customWidth="12px" />
      </div>
      <div
        className={`voteButton${voted === AGENT_CHAT_SCORE_OPTIONS.DISLIKE ? ' votedDislike' : ''}`}
        onClick={() => handleVoteAgentChat(AGENT_CHAT_SCORE_OPTIONS.DISLIKE)}
      >
        <BordOneToneIcon variant="thumbsDown" customWidth="12px" />
      </div>
    </div>
  );
};

export default AgentChatVotingSystem;

export interface AgentChatVotingSystemProps {
  agentChatResponse: IAgentResponseData;
  refreshHistory: () => Promise<void>;
}
